const editionScroll = () => {
    const subheadings = document.querySelectorAll(".subheading-contents")
    const article = document.getElementById('article_scroll_id')
    const scrollContainer = document.querySelector(".white-content-container")
    const isCutEdition = document.querySelector('.cut-edition-theme') !== null

    const scrollToElement = (element, container, offset, behavior = 'smooth') => {
        const elementRect = element.getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()
        const targetScrollTop = container.scrollTop + elementRect.top - containerRect.top - offset

        container.scrollTo({ top: targetScrollTop, behavior })
    }

    const articleId = article ? article.innerText.trim() : null
    const myArticle = articleId ? document.getElementById(`article-${articleId}`) : null

    if (myArticle && scrollContainer) {
        const articleOffset = isCutEdition ? 24 : 200

        // Images above the target have no reserved size (Cloudinary), so they
        // cause layout shifts. Wait for every image in the container to finish
        // loading so the layout is stable, then smooth-scroll precisely once.
        const images = Array.from(scrollContainer.querySelectorAll('img'))
        const loaded = images.map(img =>
            img.complete
                ? Promise.resolve()
                : new Promise(resolve => {
                    img.addEventListener('load',  resolve, { once: true })
                    img.addEventListener('error', resolve, { once: true })
                })
        )

        Promise.all(loaded).then(() => {
            scrollToElement(myArticle, scrollContainer, articleOffset, 'smooth')
        })
    }

    // Handle subheading clicks
    if (subheadings && scrollContainer) {
        subheadings.forEach((subheading) => {
            subheading.addEventListener('click', function(event) {
                const valueTarget = event.target.id
                const myElement = document.getElementById(`subheading-${valueTarget}`)

                if (myElement) {
                    const sectionOffset = isCutEdition ? 24 : 200
                    scrollToElement(myElement, scrollContainer, sectionOffset, 'smooth')

                    subheadings.forEach((sub) => sub.classList.remove('red-highlight'))
                    event.target.classList.add('red-highlight')
                }
            })
        })
    }
}

export { editionScroll };